// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__QWe5r","imgWrapper":"Offline_imgWrapper__jOWsg","title":"Offline_title__lSdtI","subtitle":"Offline_subtitle__BfXrK"};